/** Strings owned by the farm device grids (host / aggregator / duo / geelark) and the farm tabs. */
export const FARM_DEVICES_STRINGS = {
    // ── cloud device cards (duo / geelark) ───────────────────────────────────
    'farmdev.connect': { en: 'Connect', ru: 'Подключить' },
    'farmdev.disconnect': { en: 'Disconnect', ru: 'Отключить' },
    'farmdev.connecting': { en: 'Connecting…', ru: 'Подключение…' },
    'farmdev.not_connected': { en: 'Not connected', ru: 'Нет подключения' },
    'farmdev.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    'farmdev.screen_unavailable': { en: 'Screen unavailable ({status})', ru: 'Экран недоступен ({status})' },
    'farmdev.device_id': { en: 'Device ID', ru: 'ID устройства' },
    'farmdev.os': { en: 'OS', ru: 'ОС' },
    'farmdev.area': { en: 'Area', ru: 'Регион' },
    'farmdev.ip': { en: 'IP', ru: 'IP' },
    'farmdev.adb_endpoint': { en: 'ADB endpoint', ru: 'Адрес ADB' },
    // ── AdsPower web-reader cards ────────────────────────────────────────────
    'farmdev.adspower_browser_open': { en: 'Browser open', ru: 'Браузер открыт' },
    'farmdev.adspower_browser_closed': { en: 'Browser closed', ru: 'Браузер закрыт' },
    'farmdev.adspower_flow': { en: 'Flow', ru: 'Флоу' },
    'farmdev.adspower_no_flow': { en: 'no flow assigned', ru: 'флоу не назначен' },
    'farmdev.adspower_last_pass': { en: 'Last pass', ru: 'Последний проход' },
    'farmdev.adspower_unreachable': { en: 'Agent unreachable', ru: 'Агент недоступен' },
    'farmdev.adspower_no_devices': { en: 'No profiles reported yet', ru: 'Профили ещё не получены' },
    'farmdev.adspower_no_match': { en: 'No profiles match the search', ru: 'Нет профилей по запросу' },
    'farmdev.adspower_search_placeholder': { en: 'Search profile…', ru: 'Поиск профиля…' },
    'farmdev.adspower_profile_id': { en: 'Profile ID', ru: 'ID профиля' },
    'farmdev.adspower_browser': { en: 'Browser', ru: 'Браузер' },
    'farmdev.adspower_app': { en: 'App', ru: 'Приложение' },
    'farmdev.adspower_task': { en: 'Task', ru: 'Задача' },
    'farmdev.adspower_last_error': { en: 'Last error', ru: 'Последняя ошибка' },
    'farmdev.adspower_log_failed': { en: 'Could not load the log ({status})', ru: 'Не удалось загрузить лог ({status})' },
    // ── Mercado API account cards ────────────────────────────────────────────
    'farmdev.mercado_howto_title': { en: 'How to get the token and CVU', ru: 'Как получить токен и CVU' },
    'farmdev.mercado_add_btn': { en: '+ Add account', ru: '+ Добавить аккаунт' },
    'farmdev.mercado_add_title': { en: 'Add Mercado Pago account', ru: 'Добавить аккаунт Mercado Pago' },
    'farmdev.mercado_edit_title': { en: 'Edit {name}', ru: 'Изменить {name}' },
    'farmdev.mercado_label': { en: 'Name', ru: 'Название' },
    'farmdev.mercado_label_ph': { en: 'Blank — the Mercado Pago nickname', ru: 'Пусто — ник в Mercado Pago' },
    'farmdev.mercado_label_required': { en: 'Name is required', ru: 'Укажите название' },
    'farmdev.mercado_cvu_hint': { en: '22 digits — the account transfers arrive on.', ru: '22 цифры — счёт, на который приходят переводы.' },
    'farmdev.mercado_cvu_invalid': { en: 'CVU must be 22 digits', ru: 'CVU — это 22 цифры' },
    'farmdev.mercado_token': { en: 'Access Token', ru: 'Access Token' },
    'farmdev.mercado_token_hint': {
        en: 'Production Access Token (APP_USR-…) from Credenciales de producción. Test keys are refused.',
        ru: 'Боевой Access Token (APP_USR-…) из Credenciales de producción. Тестовые ключи не принимаются.',
    },
    'farmdev.mercado_token_keep': { en: 'Leave blank to keep the current key.', ru: 'Оставьте пустым, чтобы не менять ключ.' },
    'farmdev.mercado_token_required': { en: 'Access Token is required', ru: 'Укажите Access Token' },
    'farmdev.mercado_lazy_label': { en: 'Lazy polling', ru: 'Ленивый опрос' },
    'farmdev.mercado_lazy_hint': {
        en: 'Ask the platform first and read Mercado Pago only while it expects a deposit on this CVU. Off — read Mercado Pago every interval.',
        ru: 'Сначала спрашивать платформу и читать Mercado Pago только пока она ждёт депозит на этот CVU. Выкл. — читать Mercado Pago каждый интервал.',
    },
    'farmdev.lazy_poll': { en: 'Lazy polling', ru: 'Ленивый опрос' },
    'farmdev.lazy_expected': { en: 'Expected deposits', ru: 'Ожидается депозитов' },
    'farmdev.lazy_waiting': { en: 'Waiting for a deposit', ru: 'Ждёт депозит' },
    'farmdev.mercado_save_failed': { en: 'Could not save the account', ru: 'Не удалось сохранить аккаунт' },
    'farmdev.mercado_restart_warning': {
        en: 'Saved, but the poller was not restarted: {reason}',
        ru: 'Сохранено, но опрос не перезапущен: {reason}',
    },
    'farmdev.mercado_confirm_delete': {
        en: 'Delete account {name}? Its polling stops.',
        ru: 'Удалить аккаунт {name}? Его опрос остановится.',
    },
    'farmdev.mercado_confirm_stop': {
        en: 'Stop polling {name}? Incoming transfers will not be reported until it is started again.',
        ru: 'Остановить опрос {name}? Входящие переводы не будут отправляться, пока его снова не запустят.',
    },
    'farmdev.mercado_start': { en: 'Start polling', ru: 'Запустить опрос' },
    'farmdev.mercado_stop': { en: 'Stop polling', ru: 'Остановить опрос' },
    'farmdev.mercado_state': { en: 'State', ru: 'Состояние' },
    'farmdev.mercado_state_running': { en: 'Polling', ru: 'Опрос идёт' },
    'farmdev.mercado_state_error': { en: 'Error', ru: 'Ошибка' },
    'farmdev.mercado_state_pending': { en: 'Starting…', ru: 'Запускается…' },
    'farmdev.mercado_state_stopped': { en: 'Stopped', ru: 'Остановлен' },
    'farmdev.mercado_account': { en: 'Mercado Pago account', ru: 'Аккаунт Mercado Pago' },
    'farmdev.mercado_last_poll': { en: 'Last poll', ru: 'Последний опрос' },
    'farmdev.mercado_last_deposit': { en: 'Last deposit', ru: 'Последний депозит' },
    'farmdev.mercado_deposits_sent': { en: 'Deposits sent', ru: 'Отправлено депозитов' },
    'farmdev.mercado_log_empty': { en: 'The poller has logged nothing yet', ru: 'Опрос ещё ничего не записал' },
    'farmdev.mercado_no_devices': { en: 'No accounts yet', ru: 'Аккаунтов пока нет' },
    'farmdev.mercado_list_failed': { en: 'Could not load the accounts', ru: 'Не удалось загрузить аккаунты' },
    'farmdev.mercado_runner_off': { en: 'mercado-runner is not configured on the panel', ru: 'mercado-runner не настроен в панели' },
    'farmdev.mercado_runner_down': { en: 'mercado-runner is unreachable', ru: 'mercado-runner недоступен' },
    'farmdev.mercado_farm_not_ready': {
        en: 'Set the platform server and bucket code in the farm settings',
        ru: 'Задайте сервер платформы и код бакета в настройках фермы',
    },
    'farmdev.clicker': { en: 'Clicker', ru: 'Кликер' },
    'farmdev.app': { en: 'App', ru: 'Приложение' },
    'farmdev.task': { en: 'Task', ru: 'Задача' },
    'farmdev.running': { en: 'Running', ru: 'Работает' },
    'farmdev.stopped': { en: 'Stopped', ru: 'Остановлен' },
    'farmdev.last_ping': { en: 'Last ping: {time}', ru: 'Последний пинг: {time}' },
    'farmdev.device_controls': { en: 'Device controls', ru: 'Управление устройством' },
    'farmdev.device_info': { en: 'Device info', ru: 'Информация об устройстве' },
    'farmdev.comment': { en: 'Comment', ru: 'Комментарий' },
    'farmdev.start_clicker': { en: 'Start clicker', ru: 'Запустить кликер' },
    'farmdev.stop_clicker': { en: 'Stop clicker', ru: 'Остановить кликер' },
    'farmdev.reconfigure_clicker': { en: 'Reconfigure clicker', ru: 'Перенастроить кликер' },
    'farmdev.clicker_logs': { en: 'Clicker logs', ru: 'Логи кликера' },
    'farmdev.clicker_history': { en: 'Clicker history', ru: 'История кликера' },
    'farmdev.operations_registry': { en: 'Operations registry', ru: 'Реестр операций' },
    'farmdev.enable_adb_to_start': { en: 'Enable ADB to start the clicker', ru: 'Включите ADB, чтобы запустить кликер' },
    'farmdev.adb_on_hint': { en: 'ADB enabled — click to disable', ru: 'ADB включён — нажмите, чтобы отключить' },
    'farmdev.adb_off_hint': { en: 'ADB disabled — click to enable', ru: 'ADB отключён — нажмите, чтобы включить' },
    'farmdev.confirm_adb_enable': { en: 'Enable ADB on "{name}"?', ru: 'Включить ADB на «{name}»?' },
    'farmdev.confirm_adb_disable': {
        en: 'Disable ADB on "{name}"? This will stop the clicker from running.',
        ru: 'Отключить ADB на «{name}»? Кликер больше не сможет работать.',
    },
    'farmdev.adb_toggle_failed': { en: 'ADB toggle failed', ru: 'Не удалось переключить ADB' },
    'farmdev.clicker_action_failed': { en: 'Clicker action failed', ru: 'Не удалось выполнить действие кликера' },
    'farmdev.duo_unreachable': {
        en: 'Could not reach DuoPlus. Check the API key (General) and the ADB IP whitelist (Duo Setup).',
        ru: 'Нет связи с DuoPlus. Проверьте API-ключ (Общие) и белый список IP для ADB (Duo Setup).',
    },
    'farmdev.duo_no_devices': {
        en: 'No ADB-enabled DuoPlus phones. Enable ADB on the phones in the DuoPlus console.',
        ru: 'Нет телефонов DuoPlus с включённым ADB. Включите ADB на телефонах в консоли DuoPlus.',
    },
    'farmdev.geelark_unreachable': {
        en: 'Could not reach GeeLark. Check the App ID / API key (General tab).',
        ru: 'Нет связи с GeeLark. Проверьте App ID / API-ключ (вкладка «Общие»).',
    },
    'farmdev.geelark_no_devices': {
        en: 'No powered-on GeeLark phones. Power them on in the GeeLark console.',
        ru: 'Нет включённых телефонов GeeLark. Включите их в консоли GeeLark.',
    },
    // ── aggregator provisioning (add device / QR / delete) ────────────────────
    'farmdev.add_device': { en: 'Add device', ru: 'Добавить устройство' },
    'farmdev.device_name': { en: 'Device name', ru: 'Название устройства' },
    'farmdev.device_name_ph': { en: 'e.g. Phone 1', ru: 'например, Phone 1' },
    'farmdev.device_name_required': { en: 'Device name is required', ru: 'Укажите название устройства' },
    'farmdev.failed_add_device': { en: 'Failed to add device', ru: 'Не удалось добавить устройство' },
    'farmdev.copy_full_code': { en: 'Copy full code', ru: 'Копировать код целиком' },
    'farmdev.prov_manual_hint': {
        en: 'Or provision manually — copy this code and paste it in the client\'s <strong>Provision from code</strong> field. The code is shown only now.',
        ru: 'Либо выдайте вручную — скопируйте этот код и вставьте его в поле клиента <strong>Provision from code</strong>. Код показывается только сейчас.',
    },
    'farmdev.scan_on_phone': { en: 'Scan on the phone', ru: 'Отсканируйте на телефоне' },
    'farmdev.scan_qr_hint': {
        en: 'Open the mobile farm client and scan this QR to provision <strong>{name}</strong>. The key is shown only now.',
        ru: 'Откройте клиент mobile farm и отсканируйте этот QR, чтобы выдать доступ устройству <strong>{name}</strong>. Ключ показывается только сейчас.',
    },
    'farmdev.device_qr_alt': { en: 'Device QR', ru: 'QR устройства' },
    'farmdev.download_qr': { en: 'Download QR', ru: 'Скачать QR' },
    'farmdev.done': { en: 'Done', ru: 'Готово' },
    'farmdev.delete_device': { en: 'Delete device', ru: 'Удалить устройство' },
    'farmdev.revoke_device_confirm': {
        en: 'Revoke <strong>{udid}</strong>? If the phone is connected it will be dropped immediately and can only rejoin with a new QR.',
        ru: 'Отозвать <strong>{udid}</strong>? Если телефон подключён, он будет отключён сразу и вернётся только по новому QR.',
    },
    'farmdev.pending': { en: 'pending', ru: 'ожидает' },
    'farmdev.pending_hint': {
        en: 'Not activated yet — scan the QR on the phone',
        ru: 'Ещё не активировано — отсканируйте QR на телефоне',
    },
    'farmdev.scan_to_activate': { en: 'Scan to activate', ru: 'Отсканируйте для активации' },
    'farmdev.qr_unavailable': { en: 'QR unavailable', ru: 'QR недоступен' },
    'farmdev.offline_badge': { en: 'offline', ru: 'не в сети' },
    'farmdev.agg_offline_hint': {
        en: 'Provisioned and activated, but not currently connected',
        ru: 'Выдано и активировано, но сейчас не подключено',
    },
    // ── aggregator setup steps ───────────────────────────────────────────────
    'farmdev.agg_step1': {
        en: '<strong>1.</strong> Install the mobile farm client on the phone. Download the <strong>latest</strong> APK (take the newest file in the folder):',
        ru: '<strong>1.</strong> Установите на телефон клиент mobile farm. Скачайте <strong>последний</strong> APK (берите самый свежий файл в папке):',
    },
    'farmdev.download_apk': { en: 'Download APK', ru: 'Скачать APK' },
    'farmdev.agg_step2': {
        en: '<strong>2.</strong> Open the client and follow its setup wizard — the first step turns on the <strong>screen driver</strong> (Settings ▸ Accessibility ▸ Mobile Farm Client). No root, no PC, no developer mode.',
        ru: '<strong>2.</strong> Откройте клиент и пройдите мастер настройки — на первом шаге включается <strong>драйвер экрана</strong> (Настройки ▸ Специальные возможности ▸ Mobile Farm Client). Без root, без ПК, без режима разработчика.',
    },
    'farmdev.agg_step2_note': {
        en: 'If the accessibility switch is greyed out, Android blocks it for apps installed outside the Play Store: Settings ▸ Apps ▸ Mobile Farm Client ▸ ⋮ ▸ <strong>Allow restricted settings</strong>, then turn it on again.',
        ru: 'Если переключатель специальных возможностей неактивен, Android блокирует его для приложений не из Play Store: Настройки ▸ Приложения ▸ Mobile Farm Client ▸ ⋮ ▸ <strong>Разрешить ограниченные настройки</strong>, затем включите снова.',
    },
    'farmdev.agg_step3': {
        en: '<strong>3.</strong> Provision the phone: open this farm\'s <strong>Devices</strong> tab, click <strong>Add device</strong> to get a QR, then scan it in the client (or paste the provisioning code). The phone then appears here as a device.',
        ru: '<strong>3.</strong> Выдайте доступ телефону: откройте вкладку <strong>Устройства</strong> этой фермы, нажмите <strong>Добавить устройство</strong>, получите QR и отсканируйте его в клиенте (или вставьте код). После этого телефон появится здесь как устройство.',
    },
    // ── duo setup steps ──────────────────────────────────────────────────────
    'farmdev.duo_step1': {
        en: '<strong>1.</strong> In the DuoPlus console open <strong>Automation → API</strong> and copy your <strong>API key</strong>.',
        ru: '<strong>1.</strong> В консоли DuoPlus откройте <strong>Automation → API</strong> и скопируйте свой <strong>API key</strong>.',
    },
    'farmdev.duo_step2': {
        en: '<strong>2.</strong> Paste that key into the farm\'s <strong>General</strong> tab (DuoPlus API key). The panel uses it to list this account\'s cloud phones.',
        ru: '<strong>2.</strong> Вставьте ключ во вкладку фермы <strong>Общие</strong> (DuoPlus API key). Панель использует его, чтобы получить облачные телефоны этого аккаунта.',
    },
    'farmdev.duo_step3': {
        en: '<strong>3.</strong> Enable <strong>ADB</strong> on the cloud phones you want to use (DuoPlus console → the phone\'s ADB switch, or the batch "Enable ADB" action). Only phones with ADB enabled show up here.',
        ru: '<strong>3.</strong> Включите <strong>ADB</strong> на нужных облачных телефонах (консоль DuoPlus → переключатель ADB у телефона либо массовое действие «Enable ADB»). Здесь показываются только телефоны с включённым ADB.',
    },
    'farmdev.duo_step4': {
        en: '<strong>4.</strong> Whitelist this server\'s IP for ADB. In DuoPlus open <strong>ADB → Set ADB connection IP whitelist</strong> and add:',
        ru: '<strong>4.</strong> Добавьте IP этого сервера в белый список для ADB. В DuoPlus откройте <strong>ADB → Set ADB connection IP whitelist</strong> и добавьте:',
    },
    'farmdev.duo_whitelist_note': {
        en: 'Without this IP in the whitelist DuoPlus refuses ADB connections from the panel, so the phones appear but can\'t be reached over ADB.',
        ru: 'Без этого IP в белом списке DuoPlus отклоняет ADB-подключения от панели: телефоны видны, но недоступны по ADB.',
    },
    // ── duo commands popover / one-shot ADB shell ────────────────────────────
    'farmdev.device_commands': { en: 'Device commands', ru: 'Команды устройства' },
    'farmdev.pin_placeholder': { en: 'PIN (4-16 digits)', ru: 'PIN (4-16 цифр)' },
    'farmdev.enter_pin': { en: 'Enter PIN', ru: 'Ввести PIN' },
    'farmdev.installed_apps': { en: 'Installed apps', ru: 'Установленные приложения' },
    'farmdev.adb_shell': { en: 'ADB shell', ru: 'ADB shell' },
    'farmdev.pin_invalid': { en: 'PIN must contain 4 to 16 digits', ru: 'PIN должен содержать от 4 до 16 цифр' },
    'farmdev.command_failed': { en: 'Command failed', ru: 'Команда не выполнена' },
    'farmdev.adb_shell_title': { en: 'ADB Shell — {name}', ru: 'ADB Shell — {name}' },
    'farmdev.command_placeholder': { en: 'command…', ru: 'команда…' },
    'farmdev.send': { en: 'Send', ru: 'Отправить' },
    // ── farm Terminal tab ────────────────────────────────────────────────────
    'farmdev.term_hint': {
        en: 'Runs shell commands on this farm\'s host machine. Type a command and press Enter (or click Run). Type <code>clear</code> to clear the screen.',
        ru: 'Выполняет shell-команды на хост-машине этой фермы. Введите команду и нажмите Enter (или кнопку «Выполнить»). Команда <code>clear</code> очищает экран.',
    },
    'farmdev.clear': { en: 'Clear', ru: 'Очистить' },
    'farmdev.term_input_ph': { en: 'Type a command…', ru: 'Введите команду…' },
    'farmdev.run': { en: 'Run', ru: 'Выполнить' },
    'farmdev.term_running': { en: 'running…', ru: 'выполняется…' },
    'farmdev.term_error_label': { en: 'error: ', ru: 'ошибка: ' },
    'farmdev.exit_code': { en: 'exit {code}', ru: 'выход {code}' },
    'farmdev.exit_timed_out': { en: 'exit {code} · timed out', ru: 'выход {code} · таймаут' },
    'farmdev.request_failed': { en: 'Request failed', ru: 'Запрос не выполнен' },
    // ── farm Health tab ──────────────────────────────────────────────────────
    'farmdev.health_hint': {
        en: 'Live machine health for this farm — last hour, not stored. Updates every ~30s while this tab is open.',
        ru: 'Живое состояние машины этой фермы — последний час, без сохранения. Обновляется примерно раз в 30 с, пока открыта вкладка.',
    },
    'farmdev.health_cpu': { en: 'CPU', ru: 'CPU' },
    'farmdev.health_cpu_hint': {
        en: 'CPU load at the last sample (% across all cores) and the machine\'s core count.',
        ru: 'Загрузка CPU в последнем замере (% по всем ядрам) и число ядер машины.',
    },
    'farmdev.health_mem': { en: 'Memory', ru: 'Память' },
    'farmdev.health_mem_hint': {
        en: 'RAM usage: percent of memory in use, and used / total in GB.',
        ru: 'Использование RAM: процент занятой памяти и занято / всего в ГБ.',
    },
    'farmdev.health_load': { en: 'Load (1m)', ru: 'Нагрузка (1м)' },
    'farmdev.health_load_hint': {
        en: '1-minute load average — the average number of processes waiting on the CPU. Compare with the core count: a value ≈ cores means the machine is fully loaded.',
        ru: 'Средняя нагрузка за 1 минуту — среднее число процессов, ожидающих CPU. Сравнивайте с числом ядер: значение ≈ числу ядер означает полную загрузку машины.',
    },
    'farmdev.health_dev': { en: 'Devices online', ru: 'Устройств в сети' },
    'farmdev.health_dev_hint': {
        en: 'How many devices are currently online out of the total connected to this farm.',
        ru: 'Сколько устройств сейчас в сети из общего числа подключённых к этой ферме.',
    },
    'farmdev.health_up': { en: 'Uptime', ru: 'Аптайм' },
    'farmdev.health_up_hint': {
        en: 'How long the farm machine has been running since its last OS reboot.',
        ru: 'Сколько машина фермы работает с момента последней перезагрузки ОС.',
    },
    'farmdev.health_cpu_chart': { en: 'CPU usage', ru: 'Загрузка CPU' },
    'farmdev.health_mem_chart': { en: 'Memory usage', ru: 'Использование памяти' },
    'farmdev.waiting_for_data': { en: 'waiting for data…', ru: 'ожидание данных…' },
    'farmdev.cpu_value': { en: '{pct}% · {cores} cores', ru: '{pct}% · {cores} ядер' },
    'farmdev.mem_value': { en: '{pct}% · {used}/{total} GB', ru: '{pct}% · {used}/{total} ГБ' },
    'farmdev.uptime_dh': { en: '{d}d {h}h', ru: '{d}д {h}ч' },
    'farmdev.uptime_hm': { en: '{h}h {m}m', ru: '{h}ч {m}м' },
    'farmdev.uptime_m': { en: '{m}m', ru: '{m}м' },
};
